module.exports = __webpack_public_path__ + "static/media/android.299a4ca8.png";